<template>
  <div class="card-condition connection-type">
    <div class="day-of-week__search">
      <ui-select
        v-model="timezone"
        :label="t('Timezone')"
        :placeholder="t('UTC')"
        :items="timezoneList"
        item-value="zone"
        item-title="name"
        :return-object="true"
        :hide-details="1"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';
import { useFlowTimezoneCondition } from './useFlowTimezoneCondition';

const props = defineProps<{
  conditions: Record<string, { values: string | string[] }>;
}>();

const { t } = useI18n();

const { timezoneList, timezone } = useFlowTimezoneCondition(props.conditions);
</script>

<style lang="scss"></style>
